import { useSelector } from 'react-redux';

import {
  selectCartIsGroupOrder,
  selectIsGroupOrderCurrentDinerAdmin,
  selectCartGroupOrderSpendingLimit,
  selectPricePreview,
  selectCartItems,
  selectCurentDinerAmountSpent
} from 'bento-ordering/cart/selectors/index';
import { hasExceededSpendingLimit } from 'bento-ordering/group_ordering/utils';

const useWouldExceedSpendingLimit = (cartItemId = null) => {
  const isGroupOrder = useSelector(selectCartIsGroupOrder);
  const isCurrentDinerAdmin = useSelector(selectIsGroupOrderCurrentDinerAdmin);

  const perPersonSpendinglimit = useSelector(selectCartGroupOrderSpendingLimit);
  const pricePreview = useSelector(selectPricePreview);
  const cartItems = useSelector(selectCartItems);
  const curentDinerAmountSpent = useSelector(selectCurentDinerAmountSpent);

  const hasExceededSpendingLimitResult =
    isGroupOrder && !isCurrentDinerAdmin
      ? hasExceededSpendingLimit(
          pricePreview,
          perPersonSpendinglimit,
          curentDinerAmountSpent,
          cartItemId,
          cartItems
        )
      : false;

  return {
    hasExceededSpendingLimit: hasExceededSpendingLimitResult,
    spendingLimit: perPersonSpendinglimit
  };
};

export default useWouldExceedSpendingLimit;
